import React from 'react'
import InfiniteLooper from '../../components/InfiniteLooper'

const ThirdSection = () => {
  return (
    <div className='mt-12 container mx-auto pb-12'>
      <h2 data-aos="fade-right" className="text-left text-blue-text font-bold text-3xl">
        SERVIZIO DI TERAPIA
      </h2>

      <div className='my-5'>
        <div>
          <h2 data-aos="fade-right" className="text-left text-blue-text font-bold text-2xl">
            Occupazionale
          </h2>
          <p data-aos="fade-right" className='text-left text-blue-text text-cls'>
            La terapia occupazionale integra il programma riabilitativo del paziente.
          </p>
        </div>
        <div>
          <h2 data-aos="fade-right" className="text-left text-blue-text font-bold text-2xl">
            Servizio di logopedia
          </h2>
          <p data-aos="fade-right" className='text-left text-blue-text text-cls'>
            Il servizio si occupa della valutazione e del trattamento delle disabilità comunicative globalmente
            intese e delle disfagie.
          </p>
        </div>
        <div>
          <h2 data-aos="fade-right" className="text-left text-blue-text font-bold text-2xl">
            Servizio di psicologia
          </h2>
          <p data-aos="fade-right" className='text-left text-blue-text text-cls'>
            Il servizio espleta funzioni di diagnosi e cura nell?ambito del proprio settore di competenza,
            svolgendo attività di counselling familiare.
          </p>
        </div>
        <div>
          <h2 data-aos="fade-right" className="text-left text-blue-text font-bold text-2xl">
            Servizio di radiologia
          </h2>
          <p data-aos="fade-right" className='text-left text-blue-text text-cls'>
            In dotazione moderne attrezzature in grado di fornire gli esami radiologici richiesti per le patologie
            trattate, anche nella valutazione delle disfagie con esami ad hoc.
          </p>
        </div>
        <div>
          <h2 data-aos="fade-right" className="text-left text-blue-text font-bold text-2xl">
            Consulenze
          </h2>
          <p data-aos="fade-right" className='text-left text-blue-text text-cls'>
            Ai pazienti ricoverati è assicurata l’assistenza medica specialistica attraverso l‘intervento di numerosi
            consulenti.
          </p>
        </div>
      </div>






      <div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 w-full mx-auto mt-12">
          {/* Left Column: Two small images side by side */}
          <div className="grid grid-col-1 sm:grid-cols-2 gap-4">
            {/* Small Image 1 with overlay */}
            <div
              data-aos="fade-up"
              data-aos-duration="1500"
              className="aspect-square overflow-hidden border-2 border-[#939598] relative"
            >
              <div className="flex flex-col justify- h-full p-4 sm:p-4">
                <p className="font-bold xl:text-xl underline underline-offset-2 decoration-3 text-blue-text mb-2">
                  CARTA DEI SERVIZI
                </p>
                <div>
                  <img
                    src="/images/cartaservizi.png"
                    alt="Carta dei Servizi"
                    className="lg:w-[90%] xl:w-full mr-auto object-contain"
                  />
                </div>
                <a
                  href="/images/documents/2025carta-servizi-xxiii-x.pdf"
                  target="_blank"
                  className="absolute bottom-4 right-4 hover:md:scale-[1.2] transition-all ease-linear"
                >
                  <img
                    src="/images/download-ico.png"
                    alt="Icon"
                    className="w-10 h-10 sm:w-12 sm:h-12 self-end object-contain cursor-pointer transition-transform"
                  />
                </a>
              </div>
            </div>

            {/* Small Image 2 */}
            <div
              data-aos="fade-up"
              data-aos-duration="1500"
              className="aspect-square overflow-hidden"
            >
              <img
                src="/images/vpg-flower.jpg"
                alt="Small Image 2"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column: Large Image */}
          <div
            data-aos="fade-up"
            data-aos-duration="1500"
            className="overflow-hidden"
          >
            <img
              src="/images/new/febbraio.JPG"
              alt="Large Image"
              className="w-full h-full object-cover"
            />
          </div>
        </div>




        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 w-full mx-auto mt-4 md:mt-8">
          {/* Left: Large Image */}
          <div
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-offset="50"
            className="overflow-hidden"
          >
            <img
              src="/images/new/building-2.jpeg"
              alt="Building Image"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right: Two small images in a row */}
          <div className="grid grid-col-1 sm:grid-cols-2 gap-4">
            {/* Small Image 1 */}
            <div
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-offset="50"
              className="aspect-square overflow-hidden"
            >
              <img
                src="/images/albero-fiorito.webp"
                alt="Small Image 1"
                className="w-full h-full object-cover object-bottom"
              />
            </div>

            {/* Small Image 2 */}
            <div
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-offset="50"
              className="aspect-square overflow-hidden"
            >
              <img
                src="/images/snow-bench.JPG"
                alt="Small Image 2"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

      </div>



      <div className='mt-12'>
        <p data-aos="fade-right"  className='text-cls'>
          Il programma riabilitativo supera la rieducazione di organo, puntando su un approccio olistico e interdisciplinare. Prevede l’inquadramento della patologia, 
          la valutazione delle menomazioni, delle abilità residue e dei benefici attesi. La Clinica si avvale di un’équipe multidisciplinare composta da medici, infermieri, 
          fisioterapisti specializzati e la supervisione costante del fisiatra.
        </p>
      </div>
    </div>
  )
}

export default ThirdSection